const baseUrl = process.env.REACT_APP_API_BASE_URL;

//localhost:8080 :
export const http = ( url, options = {} ) => {
    options.mode = 'cors';
    const token = localStorage.getItem( "token" );

    if ( !options.headers ) {
        options.headers = {
            'Content-Type': 'application/json'
        }
    }
    if ( token ) {
        if ( options.headers ) {
            options.headers.Authorization = `Bearer ${ token }`;
        }
    }

    return fetch( baseUrl + url, options )
};

//Accueil, CreationCv
export const getProfile = () => {
    return http( "user/profile", {
        method: "GET",
    } );
};

// Accueil et SuperAdmin
export const getUploadedFiles = () => {
    return http( "clients/uploads", {
        method: "GET",
    } );
};

export const deleteImage = ( filename ) => {
    return http( `clients/upload/${ filename }`, {
        method: "DELETE"
    } );
};

// inscription
export const registerUser = ( body ) => {
    return http( "api/v1/auth/register", {
        method: "POST",
        body: JSON.stringify( body )
    } );
};

export const forgotPassword = ( email ) => {
    return http( "api/v1/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify( { email } )
    } );
};

// Candidats.jsx
export const getAllUsersWithResumes = () => {
    return http( 'user/all-with-resumes', {
        method: "GET"
    } );
};

export const downloadUserPdf = ( userId ) => {
    return http( `user/download-pdf/${ userId }`, {
        method: "GET"
    } );
};

export const getUserPdfUrl = ( userId ) => {
    return http( `user/get-pdf-url/${ userId }`, {
        method: "GET"
    } );
};

export const getAllUsers = () => {
    return http( 'user/all', {
        method: "GET"
    } );
};

export const getAllUsersLight = () => {
    return http( 'user/allLight', {
        method: "GET"
    } );
};


export const getAllManagers = () => {
    return http( 'user/managers', {
        method: 'GET'
    } )
}

export const getAllUserNames = () => {
    return http( 'user/allName', {
        method: "GET"
    } );
};

export const getAllTempUsers = () => {
    return http( 'user-temp/all', {
        method: "GET"
    } );
};

export const deleteTempUserById = ( userId ) => {
    return http( `user-temp/delete/${ userId }`, {
        method: "DELETE"
    } )
}

export const addNewResume = ( resume ) => {
    const url = "resumes/new";
    const body = JSON.stringify( resume );

    return http( url, {
        method: 'POST',
        body
    } );
};

export const deleteResume = ( resumeId ) => {
    const url = `resumes/${ resumeId }`;
    return http( url, {
        method: "DELETE",
    } )
}

export const cloneResume = ( resumeId ) => {
    const url = `resumes/clone/${ resumeId }`;
    return http( url, {
        method: "POST",
    } )
}

export const originPdfUploads = ( filename ) => {
    const url = `user/origin-pdf-uploads/${ filename }`;
    return http( url, {
        method: "GET",
    } )
}

//CvDetail
export const getUserById = ( userId ) => {
    return http( `user/find/${ userId }`, {
        method: "GET"
    } );
};

export const getUserWithResumesById = ( userId ) => {
    return http( `user/find-with-resumes/${ userId }`, {
        method: "GET"
    } );
};

export const searchUser = ( query ) => {
    const url = 'user/search';
    const body = JSON.stringify( query );
    return http( url, {
        method: 'POST',
        body: body,
    } )
}

export const getRefCompetences = () => {
    const url = 'ref/competences/all';
    return http( url, {
        method: "GET",
    } );
}

export const getRefLanguages = () => {
    const url = 'ref/languages';
    return http( url, {
        method: "GET",
    } );
}

export const getRefLanguageLevels = () => {
    const url = 'ref/language/levels';
    return http( url, {
        method: "GET",
    } );
}

export const getRefActivitySectors = () => {
    const url = 'ref/activity/sectors';
    return http( url, {
        method: "GET",
    } );
}

export const getRefEducationLevels = () => {
    const url = 'ref/education/levels';
    return http( url, {
        method: "GET",
    } );
}

export const getBusinessUnitsMetiers = () => {
    const url = 'business-units/metiers';
    return http( url, {
        method: "GET",
    } );
}

// AppelOffre
export const getJobPostingSelectedUsers = ( jobPostingId ) => {
    const url = `user-job-postings/job-postings/${ jobPostingId }/selected-users`;
    return http( url, {
        method: 'GET',
    } );
};

export const associateUserJobPostings = ( userId, jobPostingId, resumeId ) => {
    const url = 'user-job-postings/associate';
    const body = JSON.stringify( { userId, jobPostingId, resumeId } );

    return http( url, {
        method: 'POST',
        body
    } );
};

export const disassociateUserJobPostings = ( userId, jobPostingId, resumeId ) => {
    const url = `user-job-postings/disassociate?userId=${ userId }&jobPostingId=${ jobPostingId }&cvId=${ resumeId }`;
    return http( url, {
        method: 'DELETE',
    } );
};


//SuperAdmin
export const uploadImage = ( file ) => {
    const formData = new FormData();
    formData.append( 'file', file );

    return http( "clients/upload", {
        method: 'POST',
        body: formData
    } );
};

export const updateLastLoginDate = ( userId ) => {
    const loginDate = new Date().toISOString();
    return http( `user/update-last-login-date/${ userId }`, {
        method: "PUT",
        body: JSON.stringify( { loginDate } )
    } );
};

export const changeUserRole = ( userId, newRole ) => {
    const url = `user/change-role/${ userId }`;
    const body = JSON.stringify( { role: newRole } );
    return http( url, {
        method: "POST",
        body: body,
    } );
}

export const sendEmail = ( { to, subject, content } ) => {
    const url = 'send-email';
    const body = JSON.stringify( { to, subject, content } );
    return http(url, {
        method: 'POST',
        body: body
    })
}

export const sendEmailForSkill = ( { to, subject, content } ) => {
    const url = 'send-email-skill-suggest';
    const body = JSON.stringify( { to, subject, content } );
    return http(url, {
        method: 'POST',
        body: body
    })
}
